import { css } from '@emotion/core';
import { typography, fontWeights } from '../../../styles/typography';
import { colorsPalette } from '../../../styles/colors';
import MediaQueries from '../../../styles/Grid/MediaQueries';

const borderLine = `1px solid ${colorsPalette.grey20}`;

export const containerMargin = css({
  margin: '24px 0 64px',
  [MediaQueries.mdAndUp]: {
    margin: '40px 0 96px',
  },
});

export const column = css({
  width: '100%',
  ['.enquiry-input']: {
    marginBottom: 32,
    width: '100%',
  },
});

export const enquiryInput = css({
  marginBottom: 16,
  width: '100%',
});

export const removeElement = css({
  display: 'none',
});

export const halfSelect = css({
  [MediaQueries.mdAndUp]: {
    width: 'calc(50% - 10px)',
    ['&:nth-of-type(even)']: {
      marginRight: 20,
    },
  },
  ['@supports (-ms-ime-align:auto)']: {
    width: 'calc(50% - 10.9px)',
  },
});

export const generalError = css(typography.effra14, {
  alignItems: 'center',
  border: `1px solid ${colorsPalette.red120}`,
  color: colorsPalette.red120,
  display: 'flex',
  height: 48,
  marginBottom: 25,
  width: '100%',
  [MediaQueries.lgndUp]: {
    margin: '40px 0',
  },
});

export const phoneNumberField = css({
  marginBottom: 25,
});

export const errorIcon = css({
  margin: '0 20px',
});

export const goBackButtonContainer = css({
  marginBottom: 8,
});

export const goBackButton = css(typography.effra16, {
  border: 0,
  background: colorsPalette.transparent,
  color: colorsPalette.black,
  display: 'flex',
  alignItems: 'center',
  padding: 0,
  cursor: 'pointer',
});

export const goBackButtonLabel = css({
  marginLeft: 10,
});

export const headline = css({
  fontSize: 34,
  lineHeight: 1.18,
  fontWeight: fontWeights.medium,
  color: colorsPalette.grey,
  position: 'relative',
  margin: '0 0 16px',
  letterSpacing: -0.3,
  [MediaQueries.mdAndUp]: {
    fontSize: 40,
    lineHeight: 1.2,
  },
});

export const headlineSubtitle = css(typography.effra16, {
  lineHeight: 1.5,
  color: colorsPalette.grey80,
  marginBottom: 16,
});

export const tellUsMore = css(typography.effra18, {
  lineHeight: 1.67,
  alignItems: 'center',
  background: colorsPalette.white,
  border: 'none',
  color: colorsPalette.grey,
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: 0,
  paddingLeft: 0,
  paddingRight: 15,
  width: '100%',
  marginTop: 40,
  textAlign: 'left',
});

export const chevronRotated = css({
  transform: 'rotate(180deg)',
});

export const downIcon = css({
  fontSize: 10,
});

export const dropDown = css({
  display: 'none',
});

export const activeDropDown = css({
  display: 'flex',
  flexDirection: 'column',
  flexFlow: 'wrap',
  marginTop: 15,
});

export const checkboxWrapper = css({
  borderTop: borderLine,
  margin: '17px 0 25px',
  paddingTop: 27,
  [MediaQueries.mdAndUp]: {
    paddingTop: 24,
  },
});

export const checkbox = css({
  fontSize: 16,
});

export const privacyPolicy = css({
  marginBottom: 22,
});

export const privacyLabel = css({
  lineHeight: 1.5,
  paddingRight: 7,
});

export const privacyCheckbox = css({
  width: 'auto',
  ['label:first-of-type']: {
    display: 'inline-block',
    marginBottom: 0,
  },
});

export const button = css(typography.effra14, {
  letterSpacing: 1.6,
  maxWidth: 210,
  width: '100%',
  wordBreak: 'break-all',
  [MediaQueries.mdAndUp]: {
    maxWidth: 'initial',
    minWidth: 180,
    width: 'auto',
  },
  [MediaQueries.lgAndUp]: {
    minWidth: 'initial',
  },
});

export const submitButton = css({
  display: 'block',
  maxWidth: 'none',
  marginBottom: 25,
  [MediaQueries.mdAndUp]: {
    width: '100%',
  },
});

export const thankyouDescription = css(typography.effra18, {
  marginBottom: 30,
  [MediaQueries.mdAndUp]: {
    ...typography.effra22,
    marginBottom: 40,
  },
});

export const animationContainer = css({
  maxHeight: 450,
});

export const verticalSeparatorContainer = css({
  justifyContent: 'center',
});

export const verticalSeparator = css({
  width: 1,
  height: 540,
  backgroundColor: colorsPalette.grey20,
});

export const contextualInfoTitle = css(typography.effra28, {
  lineHeight: 1.43,
  fontWeight: fontWeights.medium,
  marginBottom: 24,
});

export const phrase = css({
  display: 'flex',
  marginBottom: 16,
});

export const phraseImage = css({
  width: 18,
  height: 'auto',
  marginTop: 3,
  marginRight: 20,
});

export const phraseLabel = css(typography.effra16, {
  lineHeight: 1.5,
});

export const contactNumberBlock = css({
  display: 'block',
  marginTop: 32,
  [MediaQueries.mdAndUp]: {
    display: 'inline-block',
    minWidth: 295,
    marginTop: 39,
  },
  [MediaQueries.lgAndUp]: {
    minWidth: 'initial',
    display: 'block',
    marginTop: 32,
  },
});

export const contactNumberContent = css({
  padding: 16,
  border: `1px solid ${colorsPalette.grey10}`,
  width: '100%',
  display: 'flex',
});

export const contactNumberImageContainer = css({
  borderRadius: '50%',
  marginRight: 18,
  lineHeight: 0,
  overflow: 'hidden',
  flex: '0 0 48px',
  height: 48,
});

export const contactNumberImage = css({
  width: 48,
  height: 48,
});

export const contactNumberTitle = css(typography.effra16, {
  color: colorsPalette.teal,
  lineHeight: 1.5,
  fontWeight: fontWeights.medium,
});

export const contactNumberLink = css(typography.effra16, {
  lineHeight: 1.5,
  color: colorsPalette.black,
  textDecoration: 'none',
  ':focus, :hover': {
    textDecoration: 'underline',
  },
});

export const selectCssProps = {
  customPlaceholderCss: css({
    fontSize: 16,
  }),
  customLabelCss: css({
    fontSize: 16,
    minHeight: 56,
    paddingTop: 17,
  }),
};

export const inputCssProps = {
  customLabelCss: css({
    fontSize: 16,
  }),
  customContainerCss: css({
    height: 56,
    paddingTop: 17,
  }),
  customFieldCss: css({
    fontSize: 16,
  }),
};

export const phoneNumberFieldCssProps = {
  container: {
    minHeight: 56,
    padding: '13px 16px',
    '&[data-shrink="true"]': {
      padding: '13px 16px',
    },
  },
  placeholder: {
    position: 'absolute',
    top: 4,
  },
  dialingCode: {
    fontSize: 16,
  },
  inputValue: {
    fontSize: 16,
  },
  input: {
    fontSize: 16,
  },
};
